import type { Entity } from '@unifyapps/network/generated/models/entity';
import type { Notification as NotificationType } from '@unifyapps/network/generated/models/notification';
import type { PageCta } from '../../no-code/components/Notifications/types';

export type NotificationCategory = {
  icon: {
    name?: string;
    color?: string;
  };
  id: string;
  name: string;
  color?: 'default' | 'brand' | 'success' | 'error' | 'warning';
};

export type NotificationEventType = {
  id: string;
  name: string;
  category: string;
  group?: string;
};

export type UrlCta = {
  type: 'url';
  name?: string;
  url: string;
  /*
   * This name is coupled with the code in automation node for send notification.
   * The property name for selecting whether to open in new page is named openInNewPage over there.
   */
  openInNewPage?: boolean;
};

export type EmitPageEventCta = {
  type: 'emitPageEvent';
  name?: string;
  eventName?: string;
  eventPayload?: string;
};

export type Cta = UrlCta | PageCta | EmitPageEventCta;

export type Notification = NotificationType & {
  category?: NotificationCategory;
  cta?: Cta;
  read?: boolean;
};

export type NotificationEventTypesLookupResponse = {
  response?: {
    objects?: Record<string, Omit<Entity, 'properties'> & { properties: NotificationEventType }>;
  };
};

export type NotificationEventTypesByQueryResponse = {
  response?: {
    objects?: (Omit<Entity, 'properties'> & { properties: NotificationEventType })[];
  };
};

export type NotificationGroupType = {
  name: string;
};

export type NotificationGroupEntity = Omit<Entity, 'properties' | 'id'> & {
  properties: NotificationGroupType;
  id: string;
};

export type NotificationGroupTypesByQueryResponse = {
  response?: {
    objects?: NotificationGroupEntity[];
  };
};

export enum NotificationsPanelMode {
  Notifications = 'notifications',
  Settings = 'settings',
}
